"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _orderDetail = _interopRequireDefault(require("../order/orderDetail.vue"));
var _utils = require("@/utils");
var _permission = require("@/utils/permission");
var _uploadImage = _interopRequireDefault(require("./uploadImage"));
var _securityOrderImport = _interopRequireDefault(require("./securityOrderImport"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'orderlistDetails',
  components: {
    detailsFrom: _orderDetail.default,
    uploadImageForm: _uploadImage.default,
    SecurityOrderImport: _securityOrderImport.default
  },
  data: function data() {
    return {
      options: [{
        value: 0,
        label: '全部'
      }, {
        value: 2,
        label: '商城订单'
      }, {
        value: 1,
        label: '视频号订单'
      }],
      RefuseVisible: false,
      RefuseData: {},
      orderNo: '',
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10,
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        status: null,
        dateLimit: '',
        orderNo: '',
        page: 1,
        limit: 20,
        merId: '',
        type: '4',
        reportFlag: null
      },
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: '',
        text: '全部'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      orderStatus: null,
      checkedCities: ['订单号', '订单类型', '商户名称', '收货人', '商品名称', '实际支付', '支付方式', '订单状态', '下单时间'],
      columnData: ['订单号', '订单类型', '商户名称', '收货人', '商品名称', '实际支付', '支付方式', '订单状态', '下单时间'],
      isIndeterminate: true,
      multipleSelection: [],
      uploadDialogVisible: false,
      actionPicUrl: ''
    };
  },
  mounted: function mounted() {
    // if (checkPermi(['platform:order:page:list'])) {
    this.tableFrom.orderNo = this.$route.params.platformOrderNo;
    this.getList();
    // };
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.seachList();
    },
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    handleImport: function handleImport() {
      this.$refs.importOrder.open();
    },
    // 详情
    onOrderDetails: function onOrderDetails(data) {
      this.orderNo = data.platformOrderNo;
      this.actionPicUrl = data.actionPicUrl;
      this.$refs.orderDetail.getDetail(data);
      this.$refs.orderDetail.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.status = '';
      if (this.orderStatus === 0) {
        this.tableFrom.status = 'spike';
      }
      if (this.orderStatus === 6) {
        this.tableFrom.status = 'complete';
      }
      (0, _order.orderListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total;
        _this.listLoading = false;
        _this.checkedCities = _this.$cache.local.has('order_stroge') ? _this.$cache.local.getJSON('order_stroge') : _this.checkedCities;
        _this.$nextTick(function () {
          if (_this.$refs.multipleTable) {
            _this.$refs.multipleTable.clearSelection();
          }
        });
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this2 = this;
      (0, _order.orderStatusNumApiByVirtual)({
        dateLimit: this.tableFrom.dateLimit,
        type: this.tableFrom.type,
        status: this.tableFrom.status
      }).then(function (res) {
        _this2.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    renderHeader: function renderHeader(h) {
      var _this3 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this3.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    exports: function exports() {
      var _this4 = this;
      this.listLoading = true;
      if (this.orderStatus === 0) {
        this.tableFrom.status = 'spike';
      }
      if (this.orderStatus === 6) {
        this.tableFrom.status = 'complete';
      }
      (0, _order.maintenanceOrderExcelApi)(this.tableFrom).then(function (res) {
        _this4.listLoading = false;
        window.open(res.fileName);
      }).catch(function () {
        _this4.listLoading = false;
      });
      ;
    },
    //表格选中
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchWriteOff: function batchWriteOff() {
      var _this5 = this;
      if (this.multipleSelection.length === 0) return this.$message.success('请先选择订单');
      var ids = this.multipleSelection.map(function (item) {
        return item.platformOrderNo;
      });
      this.$modalSure('批量核销订单吗？').then(function () {
        (0, _order.orderVerifyBatchApi)({
          verifyCodeList: ids
        }).then(function () {
          _this5.$message.success('批量核销订单成功！');
          _this5.getList();
        });
      });
    },
    // 批量生成检测报告
    batchReport: function batchReport() {
      var _this6 = this;
      if (this.multipleSelection.length === 0) return this.$message.success('请先选择订单');
      var ids = this.multipleSelection.map(function (item) {
        return item.platformOrderNo;
      });
      (0, _order.reportBatchApi)({
        orderNos: ids
      }).then(function (res) {
        _this6.$message.success('批量生成检测报告订单成功！');
      });
    },
    // 检测报告预览
    onPreviewReport: function onPreviewReport(data) {
      // 打开新标签页
      window.open(data.reportUrl, '_blank');
    },
    onUploadImage: function onUploadImage(data) {
      this.actionPicUrl = data.actionPicUrl;
      this.orderNo = data.platformOrderNo;
      // this.$refs.uploadImageForm.getDetail(data);
      this.uploadDialogVisible = true;
    },
    hideUploadDialog: function hideUploadDialog() {
      this.uploadDialogVisible = false;
    }
  }
};